import React from 'react';
import PropTypes from 'prop-types';

import contractPage from 'hoc/contractPage/contractPage';

import ContractTemplate from '../patterns/ContractTemplate/ContractTemplate';

export function Card({ pageContent }) {
  return (
    <ContractTemplate title="Contrato do cartão">
      {/* eslint-disable-next-line react/no-danger */}
      <div dangerouslySetInnerHTML={{ __html: pageContent }} />
    </ContractTemplate>
  );
}

Card.propTypes = {
  pageContent: PropTypes.string.isRequired,
};

export default contractPage(Card, {
  routeKey: 'CREDIT_CARD_CONTRACT',
  googleDocumentId: '1GKkCAdtnCMHwq2ZXjaBrosVf1i6sr0Dxy6uJKtIIaw8',
});
